import { InternalMedFormIcon } from "../internal/MedFormIcon.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/med-form-icon/variants/MedFormInjectionIcon.tsx
const MedFormInjectionIcon = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(InternalMedFormIcon, {
		...props,
		svgFile: "injection-icon.svg",
		alt: t("medicationForm.injection")
	});
};

//#endregion
export { MedFormInjectionIcon };